/**
 * Created by user on bank bundle files implementation.
 */

class BankBundleFilesDetailViewController extends MUIViewController
{
    static newInstance(): BankBundleFilesDetailViewController {
        let vc = new BankBundleFilesDetailViewController("bank-bundle-files-detail-view");
        vc.initWithResource("layout/bank_bundle_files/BankBundleFilesDetailView.html");
        return vc;
    }

    private optionsButton:MUIButton = null;

    private dateLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;
    private amountLabel:MUILabel = null;
    private referenceLabel:MUILabel = null;
    private filenameLabel:MUILabel = null;

    private tableView:UITableView = null;

    viewDidLoad() {
        super.viewDidLoad();

        this.optionsButton = MUIOutlet(this, "options-btn", "MUIButton");
        this.optionsButton.setAction(this, function(this:BankBundleFilesDetailViewController) {
            this.showOptions();
        });

        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
        this.referenceLabel = MUIOutlet(this, "reference-lbl", "MUILabel");
        this.filenameLabel = MUIOutlet(this, "filename-lbl", "MUILabel");

        // Configure table view for transactions
        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.delegate = this as any;
        this.tableView.dataSource = this;
    }

    viewWillAppear(animate?) {
        super.viewWillAppear(animate);
        this.updateUI();
    }

    // MARK: - Properties
    private _file: BankTransferBundleFile = null;
    set item(file: BankTransferBundleFile) {
        this._file = file;
        this.updateUI();
    }

    // MARK: - UI Updates
    private updateUI() {
        if (!this.viewIsLoaded || this._file == null) return;
        
        // Update header information
        this.referenceLabel.text = this._file.reference;
        this.dateLabel.text = this._file.referenceDateString;
        this.filenameLabel.text = this._file.name;
        this.conceptLabel.text = this._file.concept;
        this.amountLabel.text = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter.stringFromNumber( this._file.totalAmount );

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    private clearUI() {
        if (!this.viewIsLoaded) return;

        this.referenceLabel.text = "";
        this.dateLabel.text = "";
        this.filenameLabel.text = "";
        this.conceptLabel.text = "";
        this.amountLabel.text = "";

        this.tableView.reloadData();
    }

    // MARK: - Options (toolbar)

    private showOptions() {
        if (this._file == null) return;

        let avc = new MUIAlertViewController();
        avc.initWithTitle( MIOLocalizeString("OPTIONS", "OPTIONS"), MIOLocalizeString("SELECT_AN_OPTION", "SELECT AN OPTION"), MUIAlertViewStyle.Default );

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("REGENERATE_FILE", "REGENERATE FILE"), MUIAlertActionStyle.Default, this, function(this:BankBundleFilesDetailViewController) {
            if (this.installmentsCanChange()) this.showRegenerateOptions();
        } ));

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("MARK_AS_UPLOADED", "MARK AS UPLOADED"), MUIAlertActionStyle.Default, this, function(this:BankBundleFilesDetailViewController) {
            if (this.installmentsCanChange()) this.confirm( "MARK_AS_UPLOADED", "MARK_AS_UPLOADED_CONFIRMATION", MUIAlertActionStyle.Default, () => { this.markAsUploaded(); } );
        } ));

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("REMOVE_FILE", "REMOVE FILE"), MUIAlertActionStyle.Destructive, this, function(this:BankBundleFilesDetailViewController) {
            if (this.installmentsCanChange()) this.confirm( "REMOVE_FILE", "REMOVE_FILE_CONFIRMATION", MUIAlertActionStyle.Destructive, () => { this.removeFile(); } );
        } ));

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null ) );

        this.presentViewController( avc, true );
    }

    private confirm( titleKey:string, messageKey:string, style:MUIAlertActionStyle, action:() => void ) {
        let avc = new MUIAlertViewController();
        avc.initWithTitle( MIOLocalizeString(titleKey, titleKey), MIOLocalizeString(messageKey, messageKey), MUIAlertViewStyle.Default );
        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("OK", "OK"), style, this, function(this:BankBundleFilesDetailViewController) {
            action();
        } ));
        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null ) );
        AppHelper.sharedInstance().presentViewController( avc, true );
    }

    private installments(): LegalEntityPaymentInstallment[] {
        if (this._file == null) return [];
        return (this.fetchedResultsController.fetchedObjects ?? []) as LegalEntityPaymentInstallment[];
    }

    // Every installment of the file has to be untouched by the bank (file generated, or pending).
    // The server enforces the same rule; this only spares the round trip and names the offenders.
    private installmentsCanChange(): boolean {
        let blocked = this.installments().filter( (ins:LegalEntityPaymentInstallment) => {
            return ins.status != PaymentInstallmentStatus.fileGenerated && ins.status != PaymentInstallmentStatus.pending;
        } );
        if (blocked.length == 0) return true;

        let details = blocked.map( (ins:LegalEntityPaymentInstallment) => (ins.documentNumber ?? "-") + " " + ins.legalEntityName + " [" + ins.statusString() + "]" );
        AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("INSTALLMENTS_ALREADY_PROCESSED_BY_THE_BANK", "SOME INSTALLMENTS ARE ALREADY LOCKED OR PROCESSED BY THE BANK:") + " " + details.join( ", " ) );
        return false;
    }

    // MARK: Regenerate

    // Same installments, current bank data of every client. Only the creditor account and the SEPA
    // type are asked again; the due date, name and concept of the file are kept.
    private showRegenerateOptions() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle( MIOLocalizeString("REGENERATE_FILE", "REGENERATE FILE"), MIOLocalizeString("SEPA_OPTIONS", "SEPA OPTIONS"), MUIAlertViewStyle.Default );

        avc.addComboBoxWithConfigurationHandler( this, function(this:BankBundleFilesDetailViewController, comboBox:MUIComboBox) {
            comboBox.addItem( "SEPA CORE", 0 );
            comboBox.addItem( "SEPA B2B", 1 );
            comboBox.selectItem( 0 );
        } );

        avc.addComboBoxWithConfigurationHandler( this, function(this:BankBundleFilesDetailViewController, comboBox:MUIComboBox) {
            DBHelper.sharedInstance().addObserverForEntity( avc, "BankAccount", null, [MIOSortDescriptor.sortDescriptorWithKey( "info.title", true )], ["info"], function(objects:BankAccount[]) {
                comboBox.removeAllItems();
                for (let i = 0; i < objects.length; i++) comboBox.addItem( objects[i].info.title, i );
            } );
        } );

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, this, function(this:BankBundleFilesDetailViewController) {
            let type = parseInt( avc.comboBoxes[0].getSelectedItem() );
            let accountIndex = parseInt( avc.comboBoxes[1].getSelectedItem() );
            let account = DBHelper.sharedInstance().objectAtIndexForEntityObserver( avc, accountIndex, "BankAccount" ) as BankAccount;
            if (account == null) {
                AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("PLEASE_SELECT_A_BANK_ACCOUNT", "PLEASE SELECT A BANK ACCOUNT") );
                return;
            }

            this.regenerateFile( type == 1 ? "19.44" : "19.14", account );
        } ));

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null ) );

        avc.addCompletionHandler( this, function(this:BankBundleFilesDetailViewController) {
            DBHelper.sharedInstance().removeObserverForChangesInEntity( avc, "BankAccount" );
        } );

        AppHelper.sharedInstance().presentViewController( avc, true );
    }

    private regenerateFile( sepaType:string, account:BankAccount ) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.regenerateSEPAFile( this._file, sepaType, account, (result:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }

            this.downloadTextFile( result?.["name"] ?? this._file.name, result?.["content"] ?? "" );
            this.refreshFile();
        } );
    }

    // The regenerated content comes inside the JSON reply (so a server failure reaches the user as a
    // message), and the browser download is triggered here instead of by the request layer.
    private downloadTextFile( filename:string, content:string ) {
        let blob = new Blob( [content], { type: "text/plain" } );
        let url = window.URL.createObjectURL( blob );
        let a = document.createElement( "a" );
        a.href = url;
        a.download = filename;
        document.body.appendChild( a );
        a.click();
        document.body.removeChild( a );
        setTimeout( () => { window.URL.revokeObjectURL( url ); }, 100 );
    }

    // The server rewrote the reference, dates and total: pull the file again so the header reflects it.
    private refreshFile() {
        DBHelper.queryObjectWithCompletion( "BankTransferBundleFile", null, MIOPredicate.predicateWithFormat( "identifier == " + this._file.identifier ), [], this, function(this:BankBundleFilesDetailViewController, file:BankTransferBundleFile) {
            if (file != null) this._file = file;
            this.updateUI();
        } );
    }

    // MARK: Mark as uploaded / remove

    private markAsUploaded() {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.markSEPAFileAsUploaded( this._file, (result:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }

            // Mirror the server change locally, as the invoice process/unprocess flow does.
            for (let ins of this.installments()) {
                ins.status = PaymentInstallmentStatus.locked;
                ins.operationReference = this._file.reference;
            }
            DBHelper.saveMainContext();
            this.tableView.reloadData();
        } );
    }

    private removeFile() {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let file = this._file;
        ad.webService.removeSEPAFile( file, (result:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }

            // Mirror the server change locally (same as the bank removal flow): installments back to
            // pending and unlinked, then the file itself, so the list drops it.
            let installments = this.installments();
            this.fetchedResultsController = null; // detach before the changes below reach its delegate
            this._file = null;
            for (let ins of installments) {
                ins.status = PaymentInstallmentStatus.pending;
                ins.file = null;
            }
            DBHelper.deleteObjectFromMainContext( file, true );
            this.clearUI();
        } );
    }

    // MARK: - Table View Data Source

    numberOfSections(tableview: UITableView): number {
        if (this._file == null) return 0;
        return this.fetchedResultsController.sections.length;
    }
    
    numberOfRowsInSection(tableview: UITableView, section: number): number {
        if (this._file == null) return 0;
        return this.fetchedResultsController.sections[section].numberOfObjects();
    }
    
    cellAtIndexPath(tableview: UITableView, indexPath: MIOIndexPath): BankFileTransactionCell {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as LegalEntityPaymentInstallment;
        
        let cell = tableview.dequeueReusableCellWithIdentifier("BankFileTransactionCell") as BankFileTransactionCell;
        cell.item = item;
        
        return cell;
    }

    controllerDidChangeContent(controller: MIOFetchedResultsController) {
        this.tableView.reloadData();
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [
            MIOSortDescriptor.sortDescriptorWithKey('documentNumber', true)
        ];
        
        let predicateFormat = "file.identifier == " + this._file.identifier;
        let fetchRequest = DBHelper.listFetchRequestWithEntityName( "LegalEntityPaymentInstallment", sortDescriptors, predicateFormat);
        fetchRequest.relationshipKeyPathsForPrefetching = ["invoice", "legalEntity.salesLedgerAccount", "legalEntity.purchaseLedgerAccount"];
        
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
}
